import React from "react";

import Grid from "@mui/material/Grid";
import { SxProps } from "@mui/system";
import { GetProductPickerInfo } from "@src/store/slices/productPicker/types";

import { ProductList } from "./ProductList";
import { SelectAllMessage } from "./SelectAllMessage";

interface ProductSectionProps {
  sx?: SxProps;
  getProductPickerInfo?: GetProductPickerInfo;
  isView?: boolean;
}

export const ProductSection = ({
  sx,
  getProductPickerInfo,
  isView,
}: ProductSectionProps) => {
  return (
    <Grid
      sx={{ height: "100%" }}
      wrap={"nowrap"}
      container
      direction={"column"}
    >
      <SelectAllMessage />
      <Grid justifyContent={"stretch"} sx={{ height: "100%" }}>
        <ProductList
          getProductPickerInfo={getProductPickerInfo}
          isView={isView}
        />
      </Grid>
    </Grid>
  );
};
